import { Box, Button, Modal, Typography } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";

import CurrentAsignsDropdown from "./CurrentAsignsDropdown";
import OtherAsignsMenu from "./OtherAsignsMenu";
import { useSingleNivel } from "../../../../context/SuperAdmin/OASContexts/SingleNivelContext";

const AddNivelAsignsModal = () => {
  const {
    isAddModalOpen,
    toggleAddModal,
    isAdding,
    isLoadingAllAsigns,
    submitSelections,
    nivelAsigns,
  } = useSingleNivel();

  const { idNivel } = useParams();
  const [selectedAsignaturas, setSelectedAsignaturas] = useState<string[]>([]);

  const handleSubmit = () => {
    if (!nivelAsigns || !idNivel) return;

    submitSelections({ ids: selectedAsignaturas });
    setSelectedAsignaturas([]);
  };

  const handleClose = () => {
    if (!isAdding) {
      toggleAddModal(false);
    }
  };

  return (
    <Modal
      open={isAddModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "700px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {isLoadingAllAsigns ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <CurrentAsignsDropdown />

            <OtherAsignsMenu
              selectedAsignaturas={selectedAsignaturas}
              setSelectedAsignaturas={setSelectedAsignaturas}
            />

            <Box sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isAdding || !selectedAsignaturas.length}
                onClick={handleSubmit}
              >
                Agregar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AddNivelAsignsModal;
